// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TeamManagment-main-container {
  margin-top: 19px;
  padding: 0px 24px;
}
.TeamManagment-text {
  color: #061522;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 75% */
}
.Team-main-header {
  align-items: center;
  margin-top: 33px;
}
.Team-text-section {
  display: flex;
  gap: 23px;
}
.groupIcon {
  display: flex;
  cursor: auto;
}
.teamLine {
  width: 1px;
  height: 25px;
  background: #e5e9ec;
}
.team-header-text {
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  cursor: pointer;
  line-height: 18px;
}

.TeamHeaderActive {
  color: #061522;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  border-bottom: 1px solid #148dfd;
  padding-bottom: 8px;
}

.inviteButton {
  border-radius: 8px;
  background: #148dfd;
  border: none;
  color: #fff;
  outline: none;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  cursor: pointer;
  display: flex;
  align-items: center; /* vertically center icon + text */
  justify-content: center;
  width: 144px;
  margin-top: 10px;
  height: 40px;
}
.inviteButton-team {
  border-radius: 8px;
  background: #148dfd;
  border: none;
  color: #fff;
  outline: none;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  cursor: pointer;
  display: flex;
  align-items: center; /* vertically center icon + text */
  justify-content: center;
  width: 152px;
  margin-top: 10px;
  height: 40px;
}
.inviteButton-category {
  border-radius: 8px;
  background: #148dfd;
  border: none;
  color: #fff;
  outline: none;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  cursor: pointer;
  display: flex;
  align-items: center; /* vertically center icon + text */
  justify-content: center;
  width: 168px;
  margin-top: 5px;
  height: 40px;
}
.popEmail001 {
  margin-bottom: 5px;
}
.Team-Main-Container {
  margin: 16px 0px;
}
.Team-Management-Main-Container {
  margin-top: 16px;
}
.Ticket-Main-Container {
  margin: 16px 0px;
  display: flex;
  justify-content: center;
}
.PopUp-Text02 {
  cursor: pointer;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(5px);
  z-index: 1200;
  opacity: 60;
}
.Team-PopUp-Container {
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 15px 20px 0px rgba(6, 21, 34, 0.05);
  padding: 32px;
  max-width: 26.5rem;
  width: min(90vw, 26.5rem);
  height: auto;
  max-height: calc(100vh - 32px);
  overflow-y: auto;
  z-index: 1201;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.Team-PopUp-Header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Team-PopUp-Header-Group {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.PopUp-Text01 {
  color: #061522;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 100% */
}
.PopUp-Review-Text {
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
  margin-top: 5px;
}
.PopUp-Email-Container {
  margin-top: 24px;
}
.PopUp-Email-Container p {
  color: #405261;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.inviteButton-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  margin-bottom: 32px;
}
.team-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  margin-bottom: 46px;
}

.SearchInput-teamsection {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  width: 416px;
  height: 40px;
}
.SearchInput-teamsection ::placeholder {
  font-size: 14px;
  color: #c5ced6;
  font-family: "Inter", sans-serif;
  font-weight: 400;
}

.SearchTraffic {
  width: 280px;
}
.buttonStyleTeam {
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  width: 100%;
}
.buttonStyleTeam:hover {
  background: #fff !important; /* stays white */
  border-color: #c1c7cd !important; /* darker border */
  /* stronger shadow */
}
.SearchInputField-feedback {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  font-family: Inter, sans-serif;
  width: 304px;
  height: 40px;
}
.SearchInputField-teamsection {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  width: 280px;
  height: 40px;
}

.SearchInputField-article {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  font-family: Inter, sans-serif;
  width: 304px;
  height: 40px;
}
.SearchInputField-team-members {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  font-family: Inter, sans-serif;
  width: 100%;
  height: 40px;
}
.-articlePopup {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  width: 240px;
  height: 40px;
}
.SearchInputField-categorysection {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  font-family: Inter, sans-serif;
  width: 304px;
  height: 40px;
}
.buttonStyleEnable-team {
  background: #148dfd;
  border-radius: 8px;
  border: none;
  color: #fff;
  height: 40px;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  width: 100%;
}
.buttonStyleDisable-team {
  background: #f9fafa;

  color: #93a1b0;
  border: 1px solid #c5ced6;
  border-radius: 8px;

  height: 40px;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  width: 100% !important;
  cursor: not-allowed;
}

.custom-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.custom-scroll::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  min-height: 50px;
}

.custom-scroll {
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
}
`, "",{"version":3,"sources":["webpack://./src/pages/DashboardPages/TeamManagment/style.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,QAAQ;AAC7B;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB,EAAE,kCAAkC;EACvD,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB,EAAE,kCAAkC;EACvD,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB,EAAE,kCAAkC;EACvD,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,0BAA0B;EAC1B,aAAa;EACb,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,mDAAmD;EACnD,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;;EAER,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;;EAER,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;;EAEnB,YAAY;EACZ,YAAY;AACd;AACA;EACE,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;EACjD,WAAW;AACb;AACA;EACE,2BAA2B,EAAE,gBAAgB;EAC7C,gCAAgC,EAAE,kBAAkB;EACpD,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,YAAY;AACd;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;;EAEnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,YAAY;AACd;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;;EAEnB,YAAY;EACZ,YAAY;AACd;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,mBAAmB;;EAEnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;;EAElB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD","sourcesContent":[".TeamManagment-main-container {\n  margin-top: 19px;\n  padding: 0px 24px;\n}\n.TeamManagment-text {\n  color: #061522;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 75% */\n}\n.Team-main-header {\n  align-items: center;\n  margin-top: 33px;\n}\n.Team-text-section {\n  display: flex;\n  gap: 23px;\n}\n.groupIcon {\n  display: flex;\n  cursor: auto;\n}\n.teamLine {\n  width: 1px;\n  height: 25px;\n  background: #e5e9ec;\n}\n.team-header-text {\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  cursor: pointer;\n  line-height: 18px;\n}\n\n.TeamHeaderActive {\n  color: #061522;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  border-bottom: 1px solid #148dfd;\n  padding-bottom: 8px;\n}\n\n.inviteButton {\n  border-radius: 8px;\n  background: #148dfd;\n  border: none;\n  color: #fff;\n  outline: none;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  cursor: pointer;\n  display: flex;\n  align-items: center; /* vertically center icon + text */\n  justify-content: center;\n  width: 144px;\n  margin-top: 10px;\n  height: 40px;\n}\n.inviteButton-team {\n  border-radius: 8px;\n  background: #148dfd;\n  border: none;\n  color: #fff;\n  outline: none;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  cursor: pointer;\n  display: flex;\n  align-items: center; /* vertically center icon + text */\n  justify-content: center;\n  width: 152px;\n  margin-top: 10px;\n  height: 40px;\n}\n.inviteButton-category {\n  border-radius: 8px;\n  background: #148dfd;\n  border: none;\n  color: #fff;\n  outline: none;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  cursor: pointer;\n  display: flex;\n  align-items: center; /* vertically center icon + text */\n  justify-content: center;\n  width: 168px;\n  margin-top: 5px;\n  height: 40px;\n}\n.popEmail001 {\n  margin-bottom: 5px;\n}\n.Team-Main-Container {\n  margin: 16px 0px;\n}\n.Team-Management-Main-Container {\n  margin-top: 16px;\n}\n.Ticket-Main-Container {\n  margin: 16px 0px;\n  display: flex;\n  justify-content: center;\n}\n.PopUp-Text02 {\n  cursor: pointer;\n}\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(255, 255, 255, 0.6);\n  backdrop-filter: blur(5px);\n  z-index: 1200;\n  opacity: 60;\n}\n.Team-PopUp-Container {\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 15px 20px 0px rgba(6, 21, 34, 0.05);\n  padding: 32px;\n  max-width: 26.5rem;\n  width: min(90vw, 26.5rem);\n  height: auto;\n  max-height: calc(100vh - 32px);\n  overflow-y: auto;\n  z-index: 1201;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.Team-PopUp-Header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.Team-PopUp-Header-Group {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n.PopUp-Text01 {\n  color: #061522;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 100% */\n}\n.PopUp-Review-Text {\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 128.571% */\n  margin-top: 5px;\n}\n.PopUp-Email-Container {\n  margin-top: 24px;\n}\n.PopUp-Email-Container p {\n  color: #405261;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.inviteButton-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n\n  margin-bottom: 32px;\n}\n.team-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n\n  margin-bottom: 46px;\n}\n\n.SearchInput-teamsection {\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n\n  width: 416px;\n  height: 40px;\n}\n.SearchInput-teamsection ::placeholder {\n  font-size: 14px;\n  color: #c5ced6;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 400;\n}\n\n.SearchTraffic {\n  width: 280px;\n}\n.buttonStyleTeam {\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  width: 100%;\n}\n.buttonStyleTeam:hover {\n  background: #fff !important; /* stays white */\n  border-color: #c1c7cd !important; /* darker border */\n  /* stronger shadow */\n}\n.SearchInputField-feedback {\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  font-family: Inter, sans-serif;\n  width: 304px;\n  height: 40px;\n}\n.SearchInputField-teamsection {\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n\n  width: 280px;\n  height: 40px;\n}\n\n.SearchInputField-article {\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  font-family: Inter, sans-serif;\n  width: 304px;\n  height: 40px;\n}\n.SearchInputField-team-members {\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  font-family: Inter, sans-serif;\n  width: 100%;\n  height: 40px;\n}\n.-articlePopup {\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n\n  width: 240px;\n  height: 40px;\n}\n.SearchInputField-categorysection {\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  font-family: Inter, sans-serif;\n  width: 304px;\n  height: 40px;\n}\n.buttonStyleEnable-team {\n  background: #148dfd;\n  border-radius: 8px;\n  border: none;\n  color: #fff;\n  height: 40px;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  width: 100%;\n}\n.buttonStyleDisable-team {\n  background: #f9fafa;\n\n  color: #93a1b0;\n  border: 1px solid #c5ced6;\n  border-radius: 8px;\n\n  height: 40px;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  width: 100% !important;\n  cursor: not-allowed;\n}\n\n.custom-scroll::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.custom-scroll::-webkit-scrollbar-thumb {\n  background-color: rgba(0, 0, 0, 0.2);\n  border-radius: 8px;\n  min-height: 50px;\n}\n\n.custom-scroll {\n  scrollbar-width: thin;\n  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
